module.exports = __webpack_public_path__ + "static/media/background-remover-mobile@3x.2bd6562f.png";